export function assertNever(x: never, message: string | undefined = undefined): never {
  if (message)
    throw new Error(message);

  throw new Error(`Case ${x} is not properly handled !`);
}